import Swiper from "swiper";
import { Navigation } from "swiper/modules";

// Import Swiper styles needed
import "swiper/css";
import "swiper/css/navigation";

function initFeaturedCategoriesCarousel() {
  const carouselElement = document.querySelector(
    ".featured-categories-carousel"
  );

  if (!carouselElement) {
    return;
  }

  // Initialize Swiper
  const swiper = new Swiper(carouselElement, {
    modules: [Navigation],
    // Default settings (for mobile, < 768px)
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 20,

    loop: false,

    navigation: {
      nextEl: ".featured-categories-next",
      prevEl: ".featured-categories-prev",
    },

    // Responsive breakpoints
    breakpoints: {
      // when window width is >= 768px (tablet)
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      // when window width is >= 1024px (desktop)
      1024: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 20,
      },
    },
  });
}

// Run the initialization
if (
  document.readyState === "complete" ||
  document.readyState === "interactive"
) {
  initFeaturedCategoriesCarousel();
} else {
  document.addEventListener("DOMContentLoaded", initFeaturedCategoriesCarousel);
}
